export const SharedThemeStyles = {
    touchTargetHeight: '48px',
    borderRadius: '8px',
    defaultFontWeight: 'normal',
};
